import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { hasConsent } from "@/lib/consent";
import { track, trafficSource } from "@/lib/track";

// Page views + time on page, only after analytics consent
export function VisitTracker() {
  const { pathname } = useLocation();
  const [ok, setOk] = useState(hasConsent("analytics"));
  const start = useRef(Date.now());
  useEffect(() => {
    const f = () => setOk(hasConsent("analytics"));
    window.addEventListener("gs-consent", f);
    return () => window.removeEventListener("gs-consent", f);
  }, []);
  useEffect(() => {
    if (!ok) return undefined;
    start.current = Date.now();
    const send = () => {
      const s = Math.round((Date.now() - start.current) / 1000);
      if (s >= 2) track("dur", { dur: s });
      start.current = Date.now();
    };
    const t = setTimeout(() => {
      const cat = (pathname.match(/^\/kategoria\/([^/?#]+)/) || [])[1];
      let src;
      if (!sessionStorage.getItem("gs_src")) { src = trafficSource(); sessionStorage.setItem("gs_src", src); }
      track("pv", { cat: cat && decodeURIComponent(cat), src });
    }, 400);
    const onVis = () => { if (document.visibilityState === "hidden") send(); else start.current = Date.now(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearTimeout(t); document.removeEventListener("visibilitychange", onVis); send(); };
  }, [pathname, ok]);
  return null;
}

export default VisitTracker;
